import { TDrawModel } from '../../draw.model';
import { DRAW_MODEL_UTILS } from '../utils';
import { TTimelieWrapper } from './draw.tasks';
import { TTimelineModel } from '../../timeline.types';

const addPatternOnWeekend = (drawModel: TDrawModel, background: ReturnType<typeof addBackground>) => {
  console.log('Draw weekends', drawModel.timelineModel.weekends);
  const group = background
    .selectAll('.weekend-group')
    .data([drawModel])
    .join((enter) => enter.append('g'))
    .classed('weekend-group', true);

  return group
    .selectAll<d3.BaseType, TTimelineModel['timeline'][number]>('.grid-area')
    .data(drawModel.timelineModel.weekends)
    .join((enter) => {
      const svg = enter.append('svg').attr('height', '100%');
      svg
        .append('rect')
        .attr('width', '100%')
        .attr('height', '100%')
        .attr('fill', `url(#${drawModel.defsIds.checkered})`);
      return svg;
    })
    .classed('grid-area', true)
    .attr('width', drawModel.layout.widthOfDay)
    .attr('x', (d) => {
      const xPosition = DRAW_MODEL_UTILS.getPostionByDate(d, drawModel);
      return xPosition - drawModel.layout.widthOfDay / 2;
    });
};

const addBackground = (drawModel: TDrawModel, body: ReturnType<typeof drawBackground>) => {
  const background = body
    .selectAll('.background')
    .data([drawModel])
    .join('g')
    .classed('background', true)
    .attr('transform', 'translate(' + drawModel.layout.margin.left + ',0)');

  if (!drawModel.hideCalendarHoliday) addPatternOnWeekend(drawModel, background);

  return background;
};

export const drawBackground = (drawModel: TDrawModel, timelineWrapper: TTimelieWrapper) => {
  const background = timelineWrapper
    .selectAll('.background-container')
    .data([drawModel])
    .join('svg')
    .classed('background-container', true)
    .attr('width', drawModel.width + 'px')
    .attr(
      'height',
      drawModel.timelineModel.comptedEntities.totalEntities * drawModel.layout.entityHeight +
        drawModel.layout.headerHeight +
        'px',
    )
    .style('padding-top', drawModel.layout.headerHeight + 'px')
    .style('margin-bottom', '50px')
    .style('position', 'absolute')
    .style('left', '0')
    .style('pointer-events', 'none')
    .style('z-index', '-1');

  addBackground(drawModel, background);
  return background;
};
